import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-home-page',
  template: `
    <div class="home">
      <h1>Admin Portal</h1>
      <p>Select a menu item to get started.</p>
    </div>
  `,
  styles: [
    `
      .home {
        padding: 2rem;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomePage {}
